var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "sui-scroll",
    {
      staticClass: "igc-tabs",
      class: { "ig--average": _vm.average },
      style: { "background-color": _vm.mColor(16) },
      attrs: { horizontal: "" }
    },
    _vm._l(_vm.tabs, function(item, index) {
      return _c(
        "div",
        {
          key: item.id,
          staticClass: "ig--tab",
          style: {
            width: _vm.average ? "calc(100% / " + _vm.tabs.length + ")" : "",
            "font-weight": _vm.active == item.id ? 500 : 400,
            color: _vm.active == item.id ? _vm.mColor(14) : _vm.mColor(15),
            order: item.hasOwnProperty("sort") ? item.sort : index
          },
          on: {
            click: function($event) {
              return _vm.switchTab(item)
            }
          }
        },
        [
          _c("div", [_vm._v(_vm._s(item.name))]),
          _c("div", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.active == item.id,
                expression: "active == item.id"
              }
            ],
            staticClass: "ig--active",
            style: { background: _vm.mColor(14) }
          })
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }